module.exports = __webpack_public_path__ + "static/media/8.b08b66aa.jpeg";